module.exports = __webpack_public_path__ + "media/images/proof_links/colored/twitch-8a16371815b3847eab6e389c0dd73ba1.svg";